import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type CarOutOfShopPayload = {
  current_km?: number;
  car_out_of_shop?: string;
};

export const useAppointmentCarOutOfShopMutation = (appointment_id: number) => {
  const { t } = useTranslation();

  return useTypedMutation<CarOutOfShopPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/set_car_out_of_shop", { appointment_id, ...payload });
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...payload });
    },
    onError: e => toast.error(e.message.startsWith("v8_") ? t(e.message) || e.message : e.message)
  });
};
